import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder fs-3 my-1 cor_texto_1" }, "Log Acessos", -1)
const _hoisted_3 = { class: "fw-bold fs-7 cor_texto_2" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = {
  key: 0,
  class: "px-3 py-5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "0",
  ry: "0",
  width: "500",
  height: "75"
}, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "px-3 py-5"
}
const _hoisted_8 = { class: "w-100 log" }
const _hoisted_9 = { class: "pb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "Usuario", -1)
const _hoisted_11 = { style: {"text-align":"center"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Total Dias", -1)
const _hoisted_13 = { style: {"width":"150px"} }
const _hoisted_14 = { class: "" }
const _hoisted_15 = {
  class: "w-100",
  style: {"text-align":"center"}
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-10 px-3\"><div class=\"col-12 d-flex aling-items-center\"><span class=\"green ps-2 subtitle\">Maior de 50%</span></div><div class=\"col-12\"><span class=\"yellon ps-2 subtitle\">Menor de 50% e Maior de 30%</span></div><div class=\"col-12\"><span class=\"red ps-2 subtitle\">Menor de 30%</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentLoader = _resolveComponent("ContentLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h5", _hoisted_3, _toDisplayString($setup.monthSelected), 1)
    ]),
    _createElementVNode("body", _hoisted_4, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            ($setup.loading)
              ? (_openBlock(), _createBlock(_component_ContentLoader, {
                  key: 0,
                  animate: true,
                  viewBox: "0 0 400 75"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tr", _hoisted_9, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableAcesso, (acessos, key) => {
                    return (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(key), 1))
                  }), 256)),
                  _hoisted_12
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString($setup.userName), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableAcesso, (acessos) => {
                    return (_openBlock(), _createElementBlock("th", null, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(`background: ${acessos.cor};font-weight: normal;border-radius: 8px;padding:0px 5px`)
                      }, _toDisplayString(acessos.dia), 5)
                    ]))
                  }), 256)),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("p", {
                        style: _normalizeStyle(`background: ${$setup.totalAcesso?.cor};font-weight: normal;border-radius: 8px;padding:0px 10px;margin:0px`)
                      }, _toDisplayString($setup.totalAcesso?.totalAcesso), 5)
                    ])
                  ])
                ])
              ]),
              _hoisted_16
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}